module.exports = __webpack_public_path__ + "img/IMG_1699_Foamcore_MockedUp.95cacba6.jpg";